import { render, staticRenderFns } from "./ProductReviewList.vue?vue&type=template&id=70709642&scoped=true"
import script from "./ProductReviewList.vue?vue&type=script&lang=js"
export * from "./ProductReviewList.vue?vue&type=script&lang=js"
import style0 from "./ProductReviewList.vue?vue&type=style&index=0&id=70709642&prod&lang=scss"
import style1 from "./ProductReviewList.vue?vue&type=style&index=1&id=70709642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70709642",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VTab,VTabs})
